import { render } from "./ResourcesPage.vue?vue&type=template&id=41b7273a&scoped=true"
import script from "./ResourcesPage.vue?vue&type=script&lang=js"
export * from "./ResourcesPage.vue?vue&type=script&lang=js"

import "./ResourcesPage.vue?vue&type=style&index=0&id=41b7273a&lang=css"
import "./ResourcesPage.vue?vue&type=style&index=1&id=41b7273a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41b7273a"]])

export default __exports__